import React, { useRef } from 'react';

/**
 * Pestañas accesibles: rol tablist real y navegación con flechas, además del
 * contador de cambios pendientes de cada una.
 */
const Pestanas = ({ pestanas, activa, onCambiar }) => {
  const refs = useRef({});

  const alPulsarTecla = (e, indice) => {
    const teclas = { ArrowRight: 1, ArrowLeft: -1, Home: 'inicio', End: 'fin' };
    const movimiento = teclas[e.key];
    if (movimiento === undefined) return;

    e.preventDefault();
    let destino;
    if (movimiento === 'inicio') destino = 0;
    else if (movimiento === 'fin') destino = pestanas.length - 1;
    else destino = (indice + movimiento + pestanas.length) % pestanas.length;

    const siguiente = pestanas[destino];
    onCambiar(siguiente.id);
    refs.current[siguiente.id]?.focus();
  };

  return (
    <div className="perfil-tabs" role="tablist" aria-label="Secciones del perfil">
      {pestanas.map((pestana, indice) => {
        const seleccionada = activa === pestana.id;
        return (
          <button
            key={pestana.id}
            type="button"
            role="tab"
            id={`tab-${pestana.id}`}
            aria-selected={seleccionada}
            aria-controls={`panel-${pestana.id}`}
            tabIndex={seleccionada ? 0 : -1}
            ref={(el) => { refs.current[pestana.id] = el; }}
            className={seleccionada ? 'perfil-tab activo' : 'perfil-tab'}
            onClick={() => onCambiar(pestana.id)}
            onKeyDown={(e) => alPulsarTecla(e, indice)}
          >
            {pestana.label}
            {pestana.pendientes > 0 && (
              <span className="perfil-tab-badge" title="Cambios sin guardar">{pestana.pendientes}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default Pestanas;
